// Tutorial copy in 4 languages. Keep keys identical across languages.
export const LANGS = [
  { k: "en", l: "English" }, { k: "hng", l: "Hinglish" }, { k: "hi", l: "हिंदी" }, { k: "ar", l: "العربية" },
];

export const T = {
  en: {
    title: "How to Trade Our Calls", sub: "Short, simple rules to follow every Fateh FX signal correctly.",
    nav: ["Rules", "Order Types", "Lot Size", "Tips"],
    rules: [
      { h: "1. Trade Execution", items: [
        "Always try to enter at the given entry price.",
        "A 2–3 pip difference is fine, but the entry must be correct.",
        "Check the live market price against the signal before you trade.",
      ] },
      { h: "2. Layer 1 & Layer 2", items: [
        "When two entry prices are given, plan an entry at both levels.",
        "Example: SELL GOLD between 2300 – 2305 → Layer 1: SELL at 2300. If price goes up, Layer 2: SELL at 2305.",
        "If Layer 2 activates, Layer 1's target may hit first. Manage each trade with its own SL and TP.",
      ] },
      { h: "3. Trade Management", items: [
        "Always manage the trade with the planned Stop Loss (SL) and Take Profit (TP).",
        "When the first target hits, move SL to breakeven (your entry price).",
        "After booking partial profit, consider shifting SL to breakeven.",
        "Don't exit in the middle without a proper reason.",
      ] },
      { h: "4. Risk Management is the real game", items: [
        "Use a proper Stop Loss on every trade.",
        "Keep lot size according to your capital (use the calculator below).",
        "Avoid overtrading and revenge trading.",
        "Risk only a small part of your capital on one trade.",
        "Minimum TP: 50 pips — verify your broker's pip/point format.",
      ] },
    ],
    otH: "Which order type, when?",
    ot: [
      { n: "Market Buy / Sell", d: "Enter instantly at the current price. Use when price is already at our entry." },
      { n: "Buy Limit", d: "Buy BELOW the current price. Use when our buy entry is lower than the live price." },
      { n: "Sell Limit", d: "Sell ABOVE the current price. Use when our sell entry is higher than the live price." },
      { n: "Buy Stop", d: "Buy ABOVE the current price. Use for 'BUY above' breakout calls." },
      { n: "Sell Stop", d: "Sell BELOW the current price. Use for 'SELL below' breakdown calls." },
      { n: "SL & TP", d: "Set both the moment you place the order — never trade without SL." },
    ],
    otTip: "For 'BUY between 2300 – 2305' when price is above: place two Buy Limit orders at 2305 and 2300.",
    calcH: "Position Size Calculator", calcBal: "Your account balance (USD)", calcGold: "Gold", calcBtc: "Bitcoin",
    calcMax: "Max total lot", calcLayer: "Per layer (2 layers)", calcLow: "Below the minimum — add funds before trading this instrument.",
    calcRule: "Rule: Gold 0.01 lot per $100 · Bitcoin 0.01 lot per $500",
    tipsH: "Quick Tips",
    tips: [
      "Gold pip: on most brokers a 0.10 move = 1 pip (1.00 = 10 pips). Check your broker.",
      "Breakeven = SL moved to your entry price, so the trade can't turn into a loss.",
      "Don't add extra trades outside our levels.",
      "Don't move your SL further away to 'save' a trade.",
      "Skip a signal if price has already run far past the entry.",
    ],
    disc: "Risk Disclaimer: Forex and Gold trading carries a risk of financial loss. No signal or strategy guarantees profit. Trade according to your own risk management and analysis.",
    motto: "Trade Smart. Manage Risk. Stay Disciplined.",
  },
  hng: {
    title: "Hamare Calls Par Kaise Trade Karein", sub: "Har Fateh FX signal ko sahi follow karne ke short aur simple rules.",
    nav: ["Rules", "Order Types", "Lot Size", "Tips"],
    rules: [
      { h: "1. Trade Execution Rules", items: [
        "Trade hamesha diye gaye entry price par lene ki koshish karein.",
        "2–3 pips ka difference ho sakta hai, lekin entry price sahi honi chahiye.",
        "Trade lene se pehle market price aur signal ko verify karein.",
      ] },
      { h: "2. Layer 1 & Layer 2", items: [
        "Agar do entry prices diye gaye hain, to dono levels par buy/sell plan follow karein.",
        "Example: SELL GOLD between 2300 – 2305 → Layer 1: 2300 par SELL. Price upar jaye to Layer 2: 2305 par SELL.",
        "Layer 2 active ho to Layer 1 ka target pehle hit ho sakta hai. Har trade ko apne SL aur TP ke hisaab se manage karein.",
      ] },
      { h: "3. Trade Management Tips", items: [
        "Trade ko hamesha planned Stop Loss (SL) ya Take Profit (TP) ke according manage karein.",
        "First target hit hone par SL ko breakeven (cost price) par shift karein.",
        "Partial profit book karne ke baad SL ko breakeven par shift karne par vichar karein.",
        "Bina proper analysis ke beech mein trade exit na karein.",
      ] },
      { h: "4. Risk Management Hi Asli Game Hai", items: [
        "Har trade mein proper Stop Loss zaroor use karein.",
        "Apne capital ke hisaab se lot size rakhein (neeche calculator use karein).",
        "Overtrading aur revenge trading se bachein.",
        "Ek trade mein apne capital ka chhota hissa hi risk karein.",
        "Minimum TP: 50 pips — broker ke pip/point format ko verify karein.",
      ] },
    ],
    otH: "Kaunsa order type kab use karein?",
    ot: [
      { n: "Market Buy / Sell", d: "Turant current price par entry. Jab price already hamari entry par ho." },
      { n: "Buy Limit", d: "Current price se NEECHE buy. Jab hamari buy entry live price se neeche ho." },
      { n: "Sell Limit", d: "Current price se UPAR sell. Jab hamari sell entry live price se upar ho." },
      { n: "Buy Stop", d: "Current price se UPAR buy. 'BUY above' breakout calls ke liye." },
      { n: "Sell Stop", d: "Current price se NEECHE sell. 'SELL below' breakdown calls ke liye." },
      { n: "SL & TP", d: "Order lagate hi dono set karein — bina SL kabhi trade na karein." },
    ],
    otTip: "'BUY between 2300 – 2305' aur price upar ho: 2305 aur 2300 par do Buy Limit order lagayein.",
    calcH: "Position Size Calculator", calcBal: "Aapka account balance (USD)", calcGold: "Gold", calcBtc: "Bitcoin",
    calcMax: "Max total lot", calcLayer: "Har layer (2 layers)", calcLow: "Minimum se kam — is instrument me trade se pehle funds add karein.",
    calcRule: "Rule: Gold me har $100 par 0.01 lot · Bitcoin me har $500 par 0.01 lot",
    tipsH: "Quick Tips",
    tips: [
      "Gold pip: zyadatar brokers me 0.10 ka move = 1 pip (1.00 = 10 pips). Apna broker check karein.",
      "Breakeven = SL ko entry price par le aana, taaki trade loss me na jaye.",
      "Hamare levels ke bahar extra trades na lein.",
      "Trade 'bachane' ke liye SL ko door na karein.",
      "Price entry se bahut aage nikal gaya ho to signal skip karein.",
    ],
    disc: "Risk Disclaimer: Forex aur Gold trading mein financial loss ka risk hota hai. Koi bhi signal ya strategy profit ki guarantee nahi deti. Trade apne risk management aur analysis ke according karein.",
    motto: "Trade Smart. Manage Risk. Stay Disciplined.",
  },
  hi: {
    title: "हमारे कॉल्स पर कैसे ट्रेड करें", sub: "हर Fateh FX सिग्नल को सही तरीके से फॉलो करने के छोटे और आसान नियम।",
    nav: ["नियम", "ऑर्डर टाइप", "लॉट साइज़", "टिप्स"],
    rules: [
      { h: "1. ट्रेड एक्सिक्यूशन नियम", items: [
        "ट्रेड हमेशा दिए गए एंट्री प्राइस पर लेने की कोशिश करें।",
        "2–3 पिप्स का अंतर हो सकता है, लेकिन एंट्री प्राइस सही होनी चाहिए।",
        "ट्रेड लेने से पहले मार्केट प्राइस और सिग्नल को वेरिफाई करें।",
      ] },
      { h: "2. लेयर 1 और लेयर 2", items: [
        "अगर दो एंट्री प्राइस दिए गए हैं, तो दोनों लेवल पर buy/sell प्लान फॉलो करें।",
        "उदाहरण: SELL GOLD between 2300 – 2305 → लेयर 1: 2300 पर SELL। प्राइस ऊपर जाए तो लेयर 2: 2305 पर SELL।",
        "लेयर 2 एक्टिव हो तो लेयर 1 का टारगेट पहले हिट हो सकता है। हर ट्रेड को उसके SL और TP के अनुसार मैनेज करें।",
      ] },
      { h: "3. ट्रेड मैनेजमेंट टिप्स", items: [
        "ट्रेड को हमेशा प्लान किए गए Stop Loss (SL) या Take Profit (TP) के अनुसार मैनेज करें।",
        "पहला टारगेट हिट होने पर SL को ब्रेकईवन (कॉस्ट प्राइस) पर शिफ्ट करें।",
        "पार्शियल प्रॉफिट बुक करने के बाद SL को ब्रेकईवन पर शिफ्ट करने पर विचार करें।",
        "बिना सही एनालिसिस के बीच में ट्रेड एग्ज़िट न करें।",
      ] },
      { h: "4. रिस्क मैनेजमेंट ही असली गेम है", items: [
        "हर ट्रेड में सही Stop Loss ज़रूर लगाएँ।",
        "अपनी कैपिटल के हिसाब से लॉट साइज़ रखें (नीचे कैलकुलेटर देखें)।",
        "ओवरट्रेडिंग और रिवेंज ट्रेडिंग से बचें।",
        "एक ट्रेड में अपनी कैपिटल का छोटा हिस्सा ही रिस्क करें।",
        "न्यूनतम TP: 50 पिप्स — अपने ब्रोकर का pip/point फॉर्मेट वेरिफाई करें।",
      ] },
    ],
    otH: "कौन सा ऑर्डर टाइप कब इस्तेमाल करें?",
    ot: [
      { n: "Market Buy / Sell", d: "तुरंत मौजूदा प्राइस पर एंट्री। जब प्राइस पहले से हमारी एंट्री पर हो।" },
      { n: "Buy Limit", d: "मौजूदा प्राइस से नीचे buy। जब हमारी buy एंट्री लाइव प्राइस से नीचे हो।" },
      { n: "Sell Limit", d: "मौजूदा प्राइस से ऊपर sell। जब हमारी sell एंट्री लाइव प्राइस से ऊपर हो।" },
      { n: "Buy Stop", d: "मौजूदा प्राइस से ऊपर buy। 'BUY above' ब्रेकआउट कॉल्स के लिए।" },
      { n: "Sell Stop", d: "मौजूदा प्राइस से नीचे sell। 'SELL below' ब्रेकडाउन कॉल्स के लिए।" },
      { n: "SL & TP", d: "ऑर्डर लगाते ही दोनों सेट करें — बिना SL कभी ट्रेड न करें।" },
    ],
    otTip: "'BUY between 2300 – 2305' और प्राइस ऊपर हो: 2305 और 2300 पर दो Buy Limit ऑर्डर लगाएँ।",
    calcH: "पोज़िशन साइज़ कैलकुलेटर", calcBal: "आपका अकाउंट बैलेंस (USD)", calcGold: "Gold", calcBtc: "Bitcoin",
    calcMax: "अधिकतम कुल लॉट", calcLayer: "हर लेयर (2 लेयर)", calcLow: "न्यूनतम से कम — इस इंस्ट्रूमेंट में ट्रेड से पहले फंड जोड़ें।",
    calcRule: "नियम: Gold में हर $100 पर 0.01 लॉट · Bitcoin में हर $500 पर 0.01 लॉट",
    tipsH: "क्विक टिप्स",
    tips: [
      "Gold pip: ज़्यादातर ब्रोकर में 0.10 का मूव = 1 पिप (1.00 = 10 पिप्स)। अपना ब्रोकर चेक करें।",
      "ब्रेकईवन = SL को एंट्री प्राइस पर लाना, ताकि ट्रेड लॉस में न जाए।",
      "हमारे लेवल के बाहर एक्स्ट्रा ट्रेड न लें।",
      "ट्रेड 'बचाने' के लिए SL को दूर न करें।",
      "प्राइस एंट्री से बहुत आगे निकल गया हो तो सिग्नल छोड़ दें।",
    ],
    disc: "रिस्क डिस्क्लेमर: Forex और Gold ट्रेडिंग में वित्तीय नुकसान का जोखिम होता है। कोई भी सिग्नल या स्ट्रैटेजी प्रॉफिट की गारंटी नहीं देती। अपने रिस्क मैनेजमेंट और एनालिसिस के अनुसार ट्रेड करें।",
    motto: "Trade Smart. Manage Risk. Stay Disciplined.",
  },
  ar: {
    title: "كيف تتداول على توصياتنا", sub: "قواعد قصيرة وبسيطة لاتباع كل توصية من Fateh FX بشكل صحيح.",
    nav: ["القواعد", "أنواع الأوامر", "حجم اللوت", "نصائح"],
    rules: [
      { h: "1. قواعد تنفيذ الصفقة", items: [
        "حاول دائماً الدخول عند سعر الدخول المحدد.",
        "فرق 2–3 نقاط مقبول، لكن يجب أن يكون سعر الدخول صحيحاً.",
        "تحقق من سعر السوق والتوصية قبل الدخول.",
      ] },
      { h: "2. الطبقة 1 والطبقة 2", items: [
        "إذا أُعطي سعرا دخول، خطط للدخول عند المستويين.",
        "مثال: SELL GOLD between 2300 – 2305 ← الطبقة 1: بيع عند 2300. إذا ارتفع السعر، الطبقة 2: بيع عند 2305.",
        "إذا تفعّلت الطبقة 2 فقد يتحقق هدف الطبقة 1 أولاً. أدِر كل صفقة بوقف الخسارة والهدف الخاص بها.",
      ] },
      { h: "3. إدارة الصفقة", items: [
        "أدِر الصفقة دائماً وفق وقف الخسارة (SL) وجني الربح (TP) المخطط لهما.",
        "عند تحقق الهدف الأول، انقل وقف الخسارة إلى نقطة التعادل (سعر الدخول).",
        "بعد جني ربح جزئي، فكّر في نقل وقف الخسارة إلى التعادل.",
        "لا تخرج من الصفقة في المنتصف دون تحليل صحيح.",
      ] },
      { h: "4. إدارة المخاطر هي اللعبة الحقيقية", items: [
        "استخدم وقف خسارة مناسباً في كل صفقة.",
        "اجعل حجم اللوت متناسباً مع رأس مالك (استخدم الحاسبة أدناه).",
        "تجنّب الإفراط في التداول والتداول الانتقامي.",
        "خاطر بجزء صغير فقط من رأس مالك في الصفقة الواحدة.",
        "الحد الأدنى للهدف: 50 نقطة — تحقق من صيغة النقاط لدى وسيطك.",
      ] },
    ],
    otH: "أي نوع أمر ومتى؟",
    ot: [
      { n: "Market Buy / Sell", d: "دخول فوري بالسعر الحالي. عندما يكون السعر عند نقطة دخولنا." },
      { n: "Buy Limit", d: "شراء أسفل السعر الحالي. عندما يكون دخول الشراء أقل من السعر المباشر." },
      { n: "Sell Limit", d: "بيع أعلى السعر الحالي. عندما يكون دخول البيع أعلى من السعر المباشر." },
      { n: "Buy Stop", d: "شراء أعلى السعر الحالي. لتوصيات الاختراق 'BUY above'." },
      { n: "Sell Stop", d: "بيع أسفل السعر الحالي. لتوصيات الكسر 'SELL below'." },
      { n: "SL & TP", d: "حدّدهما فور وضع الأمر — لا تتداول أبداً بدون وقف خسارة." },
    ],
    otTip: "لتوصية 'BUY between 2300 – 2305' والسعر أعلى: ضع أمري Buy Limit عند 2305 و 2300.",
    calcH: "حاسبة حجم الصفقة", calcBal: "رصيد حسابك (USD)", calcGold: "الذهب", calcBtc: "البيتكوين",
    calcMax: "أقصى لوت إجمالي", calcLayer: "لكل طبقة (طبقتان)", calcLow: "أقل من الحد الأدنى — أضف رصيداً قبل التداول على هذا الأصل.",
    calcRule: "القاعدة: الذهب 0.01 لوت لكل 100$ · البيتكوين 0.01 لوت لكل 500$",
    tipsH: "نصائح سريعة",
    tips: [
      "نقطة الذهب: لدى معظم الوسطاء حركة 0.10 = نقطة واحدة (1.00 = 10 نقاط). تحقق من وسيطك.",
      "التعادل = نقل وقف الخسارة إلى سعر الدخول حتى لا تتحول الصفقة إلى خسارة.",
      "لا تفتح صفقات إضافية خارج مستوياتنا.",
      "لا تُبعد وقف الخسارة لـ'إنقاذ' صفقة.",
      "تجاوز التوصية إذا ابتعد السعر كثيراً عن نقطة الدخول.",
    ],
    disc: "تحذير المخاطر: تداول الفوركس والذهب ينطوي على مخاطر خسارة مالية. لا توجد توصية أو استراتيجية تضمن الربح. تداول وفق إدارة المخاطر والتحليل الخاص بك.",
    motto: "Trade Smart. Manage Risk. Stay Disciplined.",
  },
};
